<span class="loading" *ngIf="loading">
  <i class="fa fa-spinner fa-spin" style="font-size:40px;color:white"></i>
</span>
<app-header [screentitle]='title'></app-header>
<app-side-menu-bardashboard></app-side-menu-bardashboard>
<div class="main-content">
  <!-- <div class="heading">
    <label class="heading-text">Dashboard</label>
  </div> -->
  <div class="filters" [formGroup]="qamatrixDashboardForm">
    <div class="filtersDropdownSmall">
      <mat-form-field appearance="fill" class="datepickerwidth">
        <mat-label>Select From date</mat-label>
        <input class="datepickerwidth" matInput [matDatepicker]="picker" [min]="minDate" [max]="maxDate"
          [readonly]="inputReadonly" formControlName="fromdate" (dateChange)="dateValidation()">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker disabled="false"></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="filtersDropdownSmall">
      <mat-form-field appearance="fill" class="datepickerwidth">
        <mat-label>Select To date</mat-label>
        <input matInput [matDatepicker]="pickerTo" [min]="minDate" [max]="maxDate" [readonly]="inputReadonly"
          formControlName="todate" (dateChange)="dateValidation()">
        <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
        <mat-datepicker #pickerTo disabled="false"></mat-datepicker>
      </mat-form-field>
    </div>
    <!-- Cluster -->
    <div class="filtersDropdown">
      <mat-form-field appearance="fill" class="datepickerwidth">
        <mat-label>Select BU/Sub Region</mat-label>
        <mat-select #clusterControl [(ngModel)]="clusterdefault"
         formControlName="clusters" multiple (selectionChange)="loadSite()">
          <div class="select-all">
            <mat-checkbox [disabled]="disableCluster" [(ngModel)]="allSelected" [ngModelOptions]="{standalone: true}"
              (change)="toggleAllSelection()">
              Select All</mat-checkbox>
          </div>
          <mat-option *ngFor="let clus of cluster" (click)="optionClick()" [disabled]="disableCluster" [value]="clus">
            {{clus}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <!-- Site -->
    <div class="filtersDropdown">
      <mat-form-field appearance="fill" class="datepickerwidth">
        <mat-label>Select Site</mat-label>
        <mat-select #siteControl [(ngModel)]="sitedefault"
           formControlName="sites" multiple (selectionChange)="loadBigCategory()">
          <div class="select-all">
            <mat-checkbox [disabled]="disableSite" [(ngModel)]="siteAllSelected" [ngModelOptions]="{standalone: true}"
              (change)="toggleSiteAllSelection()">Select All</mat-checkbox>
          </div>
          <mat-option *ngFor="let fact of site" (click)="optionsiteClick()" [disabled]="disableSite" [value]="fact">
            {{fact}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <!-- Big Category -->
    <div class="filtersDropdown">
      <mat-form-field appearance="fill" class="datepickerwidth">
        <mat-label>Select Business Group</mat-label>
        <mat-select #bigCategoryControl [(ngModel)]="bigcategorydefault"
          formControlName="bigcategories" multiple (selectionChange)="assignTooltip()">
          <div class="select-all">
            <mat-checkbox [(ngModel)]="bigCategoryAllSelected" [ngModelOptions]="{standalone: true}"
              (change)="toggleBigCategoryAllSelection()">Select All</mat-checkbox>
          </div>
          <mat-option *ngFor="let categ of bigcategory" (click)="optionBigCategoryClick()" [value]="categ">{{categ}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <!-- Sub-Category -->
    <!-- <div class="dropdownsubcategory pull-right">
      <mat-form-field appearance="fill" class="datepickerwidth">
        <mat-label>Select Sub-Category</mat-label>
        <mat-select formControlName="subcategories">
          <mat-option *ngFor="let subcateg of subcategory" [value]="subcateg">{{subcateg}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div> -->
    <div class="filtersDropdown">
      <button type="button" class="btn-qm" (click)="generateReport()">
        Generate Report
      </button>
    </div>
    <div class="alert alert-danger failMsg" *ngIf="showValidationMessage">
      {{ValidationMsg}}
    </div>
    <div class="alert alert-success failMsg" *ngIf="showSuccess">
      {{recordsinserteddetails}} <br />
      {{recordupdateddetails}}
    </div>
  </div>
  <br>
  <div class="dashboard-container" [hidden]="!showDashboardContent">
    <mat-tab-group (selectedTabChange) = "onTabClick($event)" [hidden]="!showtabs" mat-align-tabs="left" animationDuration="0ms" [ngClass]="isAuthorized ? 'initialPosition' : 'pushedfromUp'">
      <mat-tab label="Pivot Table">
          <!-- <div class="heading">Quality Matrix Dashboard</div> -->
          <div class="dashboardbg" [hidden]="!dataAvailable">
            <div class="row">
                <div class="filters" [formGroup]="qamatrixDefects">
                  <!--DPI Defect Class-->
                  <div class="filtersDropdown1">
                    <mat-form-field appearance="fill" class="mat-minsize-dropdown">
                      <mat-label>DPI Defect Class</mat-label>
                      <mat-select formControlName="dpiDefectClassSelectControl" (selectionChange)="changeDefectClass()">
                        <mat-option *ngFor="let classitem of defectClassSelect" [value]="classitem">{{classitem}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <!--Defect Severity-->
                  <div class="filtersDropdown1">
                    <mat-form-field appearance="fill" class="mat-minsize-dropdown">
                      <mat-label>Defect Severity</mat-label>
                      <mat-select formControlName="defectSeveritySelectControl" (selectionChange)="changeDefectSeverity()">
                        <mat-option *ngFor="let severity of severitySelect" [value]="severity">{{severity}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <!--Defect Mode Aggregation-->
                  <div class="filtersDropdown1">
                    <mat-form-field appearance="fill" class="defectModeAggregationdropdown">
                      <mat-label>Defect Mode Aggregation</mat-label>
                      <mat-select #DefectModeAggregationControl [(ngModel)]="defectModeAggregationdefault"
                        formControlName="DefectModeAggregationControl" multiple
                        (selectionChange)="filterDatabyConditionchange()">
                        <div class="select-all">
                          <mat-checkbox [(ngModel)]="allDefectModeAggregationSelected" [ngModelOptions]="{standalone: true}"
                            (change)="toggleAllDefectModeSelection()">Select All</mat-checkbox>
                        </div>
                        <mat-option *ngFor="let aggre of defectModeAggregation" matTooltip="{{ aggre }}" [value]="aggre">
                          {{aggre}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <!--Product-->
                  <!-- <div class="filtersDropdown1">
                    <mat-form-field appearance="fill" class="mat-minsize-dropdown">
                      <mat-label>Product</mat-label>
                      <mat-select #productcontrol [(ngModel)]="productdefault" formControlName="productcontrol" multiple
                        (selectionChange)="filterDatabyConditionchange()">
                        <div class="select-all">
                          <mat-checkbox [(ngModel)]="allProductSelected" [ngModelOptions]="{standalone: true}"
                            (change)="toggleAllProductSelection()">Select All</mat-checkbox>
                        </div>
                        <mat-option *ngFor="let prod of product" [value]="prod">{{prod}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div> -->
                  <!--RecordID-->
                  <!-- <div class="filtersDropdown1">
                    <mat-form-field appearance="fill" class="mat-minsize-dropdown">
                      <mat-label>RecordID</mat-label>
                      <mat-select #RecordIDcontrol [(ngModel)]="recordiddefault" formControlName="recordidcontrol" multiple
                        (selectionChange)="filterDatabyConditionchange()">
                        <div class="select-all">
                          <mat-checkbox [(ngModel)]="allRecordIDSelected" [ngModelOptions]="{standalone: true}"
                            (change)="toggleAllRecordIDSelection()">Select All</mat-checkbox>
                        </div>
                        <mat-option *ngFor="let recid of recordid" [value]="recid">{{recid}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div> -->
                  <!--Product Line-->
                  <div class="filtersDropdown1">
                    <mat-form-field appearance="fill" class="mat-minsize-dropdown">
                      <mat-label>Product Line</mat-label>
                      <mat-select #ProductLineControl [(ngModel)]="productlinedefault" formControlName="ProductLineControl"
                        multiple (selectionChange)="filterDatabyConditionchange()">
                        <div class="select-all">
                          <mat-checkbox [(ngModel)]="allProductLineSelected" [ngModelOptions]="{standalone: true}"
                            (change)="toggleAllProductLineSelection()">Select All</mat-checkbox>
                        </div>
                        <mat-option *ngFor="let prodLine of productionline" [value]="prodLine">{{prodLine}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <!--PDCA Status-->
                  <div class="filtersDropdown1">
                    <mat-form-field appearance="fill" class="mat-minsize-dropdown">
                      <mat-label>PDCA Status</mat-label>
                      <mat-select #PDCAStatusControl [(ngModel)]="pdcastatusdefault" formControlName="PDCAStatusControl"
                        multiple (selectionChange)="filterDatabyConditionchange()">
                        <div class="select-all">
                          <mat-checkbox [(ngModel)]="allPDCASelected" [ngModelOptions]="{standalone: true}"
                            (change)="toggleAllPDCASelection()">Select All</mat-checkbox>
                        </div>
                        <mat-option *ngFor="let pdca of pdcastatus" [value]="pdca">{{pdca}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <!--Export Excel Button-->
                  <div class="filtersDropdown1">
                    <button type="button" class="btn-qm" (click)="exportExcel()"> 
                      <i class="export-icon"></i>Export Excel
                    </button>
                  </div>
                  <!--Save Button-->
                  <div class="filtersDropdown1">
                    <button type="button" class="btn-qm" (click)="saveAgreement()" [disabled]="role == 'QGR'">
                      <i class="save-icon"></i>Save
                    </button>
                  </div>
                </div>
                <div [ngClass]="isAuthorized ? 'initialPosition' : 'pushedfromUp'">
                  <div *ngIf="nofiltereddata" class="records">{{noRecords}}</div>
                  <div class="mat-elevation-z8" [hidden]="nofiltereddata" [ngClass]="isAuthorized ? '' : 'newHeight'">
                    <mat-paginator #paginator 
                                    [pageSize]="5"
                                    [pageSizeOptions]="[5, 10, 20,30]"
                                    showFirstLastButtons >
                    </mat-paginator>
                    <table mat-table [dataSource]="dataSource">
                      <!-- Defect MODE Column -->
                      <ng-container matColumnDef="Defect MODE Aggregation (Level 1+2+3+4)">
                        <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Loss Tree Defect MODE Aggregation (Level 1+2+3+4) </th>
                        <td class="leftDataCell" mat-cell *matCellDef="let element">
                          <span>{{element.defectmodeaggregation}}</span>
                        </td>
                      </ng-container>
                       <!-- level 0 Column -->
                       <ng-container matColumnDef="Level0">
                        <th class="leftHeaderCell" mat-header-cell  *matHeaderCellDef> Level 0 </th>
                        <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.leveL0}} </td>
                      </ng-container>
                      <!-- 4Ms Column -->
                      <ng-container matColumnDef="4Ms">
                        <th class="leftHeaderCell" mat-header-cell  *matHeaderCellDef> 4Ms </th>
                        <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.fourms}} </td>
                      </ng-container>
                      <!-- Cluster Column -->
                      <ng-container matColumnDef="BU/Sub Region">
                        <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Cluster </th>
                        <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.subregion}} </td>
                      </ng-container>
                      <!-- Sites Column -->
                      <ng-container matColumnDef="Sites">
                        <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Site </th>
                        <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.sites}} </td>
                      </ng-container>
                      <!-- Big Category Column -->
                      <ng-container matColumnDef="Business Group">
                        <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Big Category </th>
                        <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.businessgroup}} </td>
                      </ng-container>
                      <!-- Product Column -->
                      <!-- <ng-container matColumnDef="Product">
                        <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Product </th>
                        <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.product}} </td>
                      </ng-container> -->
                      <!-- RecordID Column -->
                      <!-- <ng-container matColumnDef="RecordID">
                        <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> RecordID </th>
                        <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.recordid}} </td>
                      </ng-container> -->
                      <!-- Product line Column -->
                      <ng-container matColumnDef="Production line">
                        <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Production line </th>
                        <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.productionline}} </td>
                      </ng-container>
                      <!-- DPI Total Column -->
                      <ng-container matColumnDef="Defect Priority Index">
                        <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Defect Priority Index </th>
                        <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.defectpriorityindex | number}} </td>
                      </ng-container>
                      <!-- PDCA Column -->
                      <ng-container matColumnDef="PDCA Status">
                        <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> PDCA Status </th>
                        <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.pdcastatus}} </td>
                        <!-- <td class="leftDataCell" class="leftDataCell" mat-cell *matCellDef="let element">
                          <select [(ngModel)] = "element.pdcastatus" id="PDCAStatus">
                            <option value="not started">Not started</option>
                            <option value="plan">Plan</option>
                            <option value="do">Do</option>
                            <option value="check">Check</option>
                            <option value="act">Act</option>
                            <option value="done">Done</option>
                          </select>
                        </td> -->
                      </ng-container>
                      <!-- Count Column -->
                      <ng-container matColumnDef="Occurances">
                        <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Occurances </th>
                        <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.occurances}} </td>
                      </ng-container>
                      <!-- Agreement Column -->
                      <ng-container matColumnDef="Agreement">
                        <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Agreement </th>
                        <td class="leftDataCell" mat-cell *matCellDef="let element">
                          <select [(ngModel)]="element.agreement"
                            [disabled]="(element.pdcastatus !== 'plan' && element.pdcastatus !== 'not started') || agreementRemarksDisable || role == 'QGR'"
                            id="Agreement">
                            <option value="Agree">Agree</option>
                            <option value="Disagree">Disagree</option>
                          </select>
                        </td>
                      </ng-container>
                      <!-- Remarks Column -->
                      <ng-container matColumnDef="Remarks">
                        <th class="rightHeaderCell" mat-header-cell *matHeaderCellDef> Remarks </th>
                        <td class="rightDataCell" mat-cell *matCellDef="let element">
                          <!-- <input class="input-width" type="text"  name="remarks" [(ngModel)] = "element.remarks" maxlength="150"> -->
                          <textarea class="input-width" name="Text1" cols="25" rows="3" [(ngModel)]="element.remarks"
                            maxlength="150" [disabled]="agreementRemarksDisable || role == 'QGR'"></textarea>
                        </td>
                      </ng-container>
        
                      <tr mat-header-row *matHeaderRowDef="defectModeColumns;sticky: true"></tr>
                      <tr mat-row *matRowDef="let row; columns: defectModeColumns;"></tr>
                    </table>
                  </div>
                </div>
            </div>
          </div>
      </mat-tab>
      <mat-tab label="4Ms & PDCA Chart">
        <div class="dashboard-main-content fixed-height-piechart" *ngIf="dataAvailable">
          <div class="dashboardbg">
            <div class="dashboard-block">
              <app-defects-count-block [defectClassArray]="defectClassArray"></app-defects-count-block>
            </div>
            <div class="dashboard-block">
              <div class="pdca-container">
                <p class="dpi-heading">{{mdistribution}}</p>
                <app-pie-chart-sql [fourmsData]="fourmsData" *ngIf="showPieChart"></app-pie-chart-sql>
              </div>
            </div>
            <div class="dashboard-block">
              <div class="pdca-container2">
                <p class="dpi-heading">{{pdca}}</p>
                <app-pie-chart-pdca-sql [pdcaData]="pdcaData" *ngIf="showPieChartPdca"></app-pie-chart-pdca-sql>
              </div>
            </div>
            <div class="dashboard-block">
              <div [ngClass]="isAuthorized ? 'initialPosition' : 'pushedfromUp'">
                <div *ngIf="noIncidence" class="records">{{noRecords}}</div>
                <div class="incidence-container">
                  <table id="tbldefectlevel" *ngIf="!noIncidence">
                    <thead>
                      <tr>
                        <th>Level(0) Defects</th>
                        <th class="rightDataCell">Count</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let element of incidenceArray">
                        <td [ngClass]="{'rowcolor': element.leveL0 === 'Total'}"><span>{{element.leveL0}}</span></td>
                        <td class="rightDataCell" [ngClass]="{'rowcolor': element.leveL0 === 'Total'}"><span>{{element.count}}</span></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Defect Cost Analysis">
        <div class="dashboard-main-content fixed-height" *ngIf="dataAvailable">
          <div [ngClass]="isAuthorized ? 'initialPosition' : 'pushedfromUp'">
            <!-- <div class="heading">Defect Cost Analysis</div> -->
            <div *ngIf="noDefectCost" class="records">{{noRecords}}</div>
            <div class="dashboard-container-defect-class mat-elevation-z8" [ngClass]="isAuthorized ? '' : 'newHeight'">
              <table id="defectcostanalysis" *ngIf="!noDefectCost">
                <thead>
                  <tr>
                    <th>Detectability Category</th>
                    <th class="rightDataCell">Total Defect Cost Per Category</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let element of defectCostArray">
                    <td [ngClass]="{'rowcolor': element.categoryid === 'Grand Total in EURO'}">{{element.categoryid}}</td>
                    <td class="rightDataCell" [ngClass]="{'rowcolor-rightalign': element.categoryid === 'Grand Total in EURO'}">{{element.totaldefectcostpercategory}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Defect Pareto">
        <div class="filters filters-wrapper-pareto" [formGroup] = "qamatrixDefectsParetoForm">
          <!--DPI Defect Class-->
          <div class="filtersDropdown">
            <mat-form-field appearance="fill" class="mat-minsize-dropdown">
              <mat-label>DPI Defect Class</mat-label>
              <mat-select formControlName="dpiDefectClassSelectControl" [(ngModel)]="dpiDefectClassSelectControlValue" (selectionChange)="changeDefectClass()">
                <mat-option *ngFor="let classitem of defectClassSelect" [value]="classitem">{{classitem}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <!--Defect Severity-->
          <div class="filtersDropdown">
            <mat-form-field appearance="fill" class="mat-minsize-dropdown">
              <mat-label>Defect Severity</mat-label>
              <mat-select formControlName="defectSeveritySelectControl" (selectionChange)="changeDefectSeverity()">
                <mat-option *ngFor="let severity of severitySelect" [value]="severity">{{severity}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <!-- Site -->
          <div class="filtersDropdown">
            <mat-form-field appearance="fill" class="mat-minsize-dropdown">
              <mat-label>Select Site</mat-label>
              <mat-select #siteControl [(ngModel)]="sitedefault"
                formControlName="sites" multiple (selectionChange)="loadBigCategory()">
                <div class="select-all">
                <mat-checkbox [disabled]="disableSite" [(ngModel)]="siteAllSelected" [ngModelOptions]="{standalone: true}"
                  (change)="toggleSiteAllSelection()">Select All</mat-checkbox>
                </div>
                <mat-option *ngFor="let fact of site" (click)="optionsiteClick()" [disabled]="disableSite" [value]="fact">
                  {{fact}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <!-- Big Category -->
          <div class="filtersDropdown">
            <mat-form-field appearance="fill" class="mat-medsize-dropdown">
              <mat-label>Select Big Category</mat-label>
              <mat-select #bigCategoryControl [(ngModel)]="bigcategorydefault"
                formControlName="bigcategories" multiple (selectionChange)="assignTooltip()">
                <div class="select-all">
                <mat-checkbox [(ngModel)]="bigCategoryAllSelected" [ngModelOptions]="{standalone: true}"
                  (change)="toggleBigCategoryAllSelection()">Select All</mat-checkbox>
                </div>
                <mat-option *ngFor="let categ of bigcategory" (click)="optionBigCategoryClick()" [value]="categ">{{categ}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div>
          <app-pareto-report [paretoReportData]="paretoReportArray"></app-pareto-report>
        </div>
      </mat-tab>
      <mat-tab label="Process Pareto">
        <div class="filters filters-wrapper-pareto" [formGroup] = "qamatrixParetoForm">
          <!--DPI Defect Class-->
          <div class="filtersDropdown">
            <mat-form-field appearance="fill" class="mat-minsize-dropdown">
              <mat-label>DPI Defect Class</mat-label>
              <mat-select formControlName="dpiDefectClassSelectControl" (selectionChange)="changeDefectClass()">
                <mat-option *ngFor="let classitem of defectClassSelect" [value]="classitem">{{classitem}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <!--Defect Severity-->
          <div class="filtersDropdown">
            <mat-form-field appearance="fill" class="mat-minsize-dropdown">
              <mat-label>Defect Severity</mat-label>
              <mat-select formControlName="defectSeveritySelectControl" (selectionChange)="changeDefectSeverity()">
                <mat-option *ngFor="let severity of severitySelect" [value]="severity">{{severity}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <!-- Site -->
          <div class="filtersDropdown">
            <mat-form-field appearance="fill" class="mat-minsize-dropdown">
              <mat-label>Select Site</mat-label>
              <mat-select #siteControl [(ngModel)]="sitedefault"
                formControlName="sites" multiple (selectionChange)="loadBigCategory()">
                <div class="select-all">
                <mat-checkbox [disabled]="disableSite" [(ngModel)]="siteAllSelected" [ngModelOptions]="{standalone: true}"
                  (change)="toggleSiteAllSelection()">Select All</mat-checkbox>
                </div>
                <mat-option *ngFor="let fact of site" (click)="optionsiteClick()" [disabled]="disableSite" [value]="fact">
                  {{fact}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <!-- Big Category -->
          <div class="filtersDropdown">
            <mat-form-field appearance="fill" class="mat-medsize-dropdown">
              <mat-label>Select Big Category</mat-label>
              <mat-select #bigCategoryControl [(ngModel)]="bigcategorydefault"
                formControlName="bigcategories" multiple (selectionChange)="assignTooltip()">
                <div class="select-all">
                <mat-checkbox [(ngModel)]="bigCategoryAllSelected" [ngModelOptions]="{standalone: true}"
                  (change)="toggleBigCategoryAllSelection()">Select All</mat-checkbox>
                </div>
                <mat-option *ngFor="let categ of bigcategory" (click)="optionBigCategoryClick()" [value]="categ">{{categ}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div>
          <app-process-pareto-report [processParetoReportData]="processParetoReportArray"></app-process-pareto-report>
        </div>
      </mat-tab>
      
    </mat-tab-group>
  </div>
</div>

